module.exports = __webpack_public_path__ + "img/HT.f84e7a48.png";